module.exports = __webpack_public_path__ + "img/CN.7d880986.svg";